import {
      BarChart,
      Bell,
      Calendar,
      Layout,
      MessageSquare,
      RefreshCw,
      Zap
} from 'lucide-react';
import { useTranslations } from 'next-intl';
import SectionPageLayout from '../layouts/section-page-layout';
import ChangelogPreview from './changelog-preview';
const Features = () => {
      const t = useTranslations('landing.features');

      return (
            <SectionPageLayout id="features" sectionClassName="bg-gray-50 dark:bg-gray-900 px-8 py-16 md:py-24 w-full">
                  <div className="text-center mb-16">
                        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-balance">
                              {t('title')}
                        </h2>
                        <p className="text-lg text-gray-600 dark:text-gray-400 max-w-3xl mx-auto text-balance">
                              {t('description')}
                        </p>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center mb-16">
                        <div className="order-2 md:order-1">
                              <div className="md:pr-8">
                                    <div className="flex flex-col gap-8">
                                          <div className="animate-slide-in">
                                                <div className="flex items-start">
                                                      <div className="bg-kiwilog/10 p-3 rounded-xl mr-4">
                                                            <Bell size={20} className="text-kiwilog" />
                                                      </div>
                                                      <div>
                                                            <h3 className="font-semibold text-xl mb-2">{t('automated_notifications')}</h3>
                                                            <p className="text-gray-600 dark:text-gray-400 text-balance">
                                                                  {t('automated_notifications_description')}
                                                            </p>
                                                      </div>
                                                </div>
                                          </div>

                                          <div className="animate-slide-in animation-delay-150">
                                                <div className="flex items-start">
                                                      <div className="bg-kiwilog/10 p-3 rounded-xl mr-4">
                                                            <MessageSquare size={20} className="text-kiwilog" />
                                                      </div>
                                                      <div>
                                                            <h3 className="font-semibold text-xl mb-2">{t('customizable_changelogs')}</h3>
                                                            <p className="text-gray-600 dark:text-gray-400 text-balance">
                                                                  {t('customizable_changelogs_description')}
                                                            </p>
                                                      </div>
                                                </div>
                                          </div>

                                          <div className="animate-slide-in animation-delay-300">
                                                <div className="flex items-start">
                                                      <div className="bg-kiwilog/10 p-3 rounded-xl mr-4">
                                                            <BarChart size={20} className="text-kiwilog" />
                                                      </div>
                                                      <div>
                                                            <h3 className="font-semibold text-xl mb-2">{t('engagement_analytics')}</h3>
                                                            <p className="text-gray-600 dark:text-gray-400 text-balance">
                                                                  {t('engagement_analytics_description')}
                                                            </p>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>

                        <div className="order-1 md:order-2 animate-scale-in">
                              <ChangelogPreview />
                        </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
                        <div className="glass-card dark:bg-gray-800 p-6 rounded-xl transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1 animate-fade-in">
                              <div className="bg-kiwilog/10 p-3 w-12 h-12 flex items-center justify-center rounded-lg mb-5">
                                    <Layout size={20} className="text-kiwilog" />
                              </div>
                              <h3 className="font-semibold text-lg mb-2">{t('customizable_ui')}</h3>
                              <p className="text-gray-600 dark:text-gray-400 text-sm text-balance">
                                    {t('customizable_ui_description')}
                              </p>
                        </div>

                        <div className="glass-card dark:bg-gray-800 p-6 rounded-xl transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1 animate-fade-in animation-delay-100">
                              <div className="bg-kiwilog/10 p-3 w-12 h-12 flex items-center justify-center rounded-lg mb-5">
                                    <Calendar size={20} className="text-kiwilog" />
                              </div>
                              <h3 className="font-semibold text-lg mb-2">{t('schedule_updates')}</h3>
                              <p className="text-gray-600 dark:text-gray-400 text-sm text-balance">
                                    {t('schedule_updates_description')}
                              </p>
                        </div>

                        <div className="glass-card dark:bg-gray-800 p-6 rounded-xl transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1 animate-fade-in animation-delay-200">
                              <div className="bg-kiwilog/10 p-3 w-12 h-12 flex items-center justify-center rounded-lg mb-5">
                                    <RefreshCw size={20} className="text-kiwilog" />
                              </div>
                              <h3 className="font-semibold text-lg mb-2">{t('version_control')}</h3>
                              <p className="text-gray-600 dark:text-gray-400 text-sm text-balance">
                                    {t('version_control_description')}
                              </p>
                        </div>

                        <div className="glass-card dark:bg-gray-800 p-6 rounded-xl transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1 animate-fade-in animation-delay-300">
                              <div className="bg-kiwilog/10 p-3 w-12 h-12 flex items-center justify-center rounded-lg mb-5">
                                    <Zap size={20} className="text-kiwilog" />
                              </div>
                              <h3 className="font-semibold text-lg mb-2">{t('widget_integration')}</h3>
                              <p className="text-gray-600 dark:text-gray-400 text-sm text-balance">
                                    {t('widget_integration_description')}
                              </p>
                        </div>
                  </div>
            </SectionPageLayout>
      );
};

export default Features;